var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"debugPanel"}},[_c('p',[_vm._v("mouse : "+_vm._s(_vm.display(_vm.mouse)))]),_c('p',[_vm._v("cursor : "+_vm._s(_vm.display(_vm.cursor)))]),_c('p',[_vm._v("hovered : "+_vm._s(_vm.hoveredInfos))])])}
var staticRenderFns = []

export { render, staticRenderFns }